/**
 * Generates a URL-safe campaign code from a campaign name
 * - Strips diacritics (č→c, á→a, etc.)
 * - Replaces spaces with dashes
 * - Converts to lowercase
 * - Example: "Nadace Help Pes" → "nadace-help-pes"
 */
export const generateCampaignCode = (name: string): string => {
  if (!name) return "";

  // Strip diacritics and convert to lowercase
  const normalized = name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase();

  // Replace spaces and special characters with dashes
  const code = normalized.replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, ""); // Remove leading/trailing dashes

  return code;
};
